import { render, staticRenderFns } from "./GKVAgreementModal.vue?vue&type=template&id=0c831c1d&"
import script from "./GKVAgreementModal.vue?vue&type=script&lang=js&"
export * from "./GKVAgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./GKVAgreementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports